import { apiFetch } from "./client";

export type PrincipalView = {
  name: string;
  vatNumber: string | null;
  website: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  postalCode: string | null;
  country: string | null;
};

export type RepView = {
  userId: string;
  displayName: string;
  email: string;
  phone: string | null;
  avatarUrl: string | null;
};

export type ContactView = {
  principal: PrincipalView;
  salesReps: RepView[];
  qualityRep: RepView | null;
};

export const contactApi = {
  getPrincipal: () => apiFetch<ContactView>("/contact/principal"),
};
